<template>
  <v-form v-model="isFormValid" ref="form">
    <div>
      <dashboard-header :text="item ? $t('sosType.updateSosType'): $t('sosType.createSosType')" :on-back="onGoBack"/>
      <div class="d-flex justify-center align-center">
        <v-card elevation="0"
                class="card-border-10 w-75">
          <v-card class="m-4"
                  outlined>
            <div class="d-flex custom-card-head p-4">
              <div class="d-inline text-sm-h5 ">{{ $t("nav.information") }}</div>
            </div>
            <v-divider class="m-0"></v-divider>
            <div class="px-6 pt-6">
              <div class="d-flex">
                <div class="text-h6 mark-title">*</div>
                <p class="ms-1 text-sm-h5">{{ $t('sosType.name') }}</p>
              </div>
              <v-textarea
                  v-model="sosType.name"
                  :placeholder="placeholderName"
                  :rules="sosTypeName"
                  counter="100"
                  rows="1"
                  auto-grow
                  outlined
              >
              </v-textarea>
              <div class="d-flex">
                <div class="text-h6 mark-title">*</div>
                <p class="ms-1 text-sm-h5">{{ $t('sosType.color') }}</p>
              </div>
              <v-select
                  v-model="sosType.color"
                  :items="colorItems"
                  outlined
                  :rules="[v => !!v || $t('ui.required')]"
              >
                <template v-slot:item="{ item }">
                  <div class="d-flex align-center">
                    <img :src="require('@/assets/images/sos-type-' + item.value + '.png')" width="24" height="24" class="me-2" />
                    {{ item.text }}
                  </div>
                </template>
                <template v-slot:selection="{ item }">
                  <div class="d-flex align-center">
                    <img :src="require('@/assets/images/sos-type-' + item.value + '.png')" width="24" height="24" class="me-2" />
                    {{ item.text }}
                  </div>
                </template>
              </v-select>
              <!-- <div class="d-flex">
                <div class="text-h6 mark-title">*</div>
                <p class="ms-1 text-sm-h5">{{ $t('sosType.nameEng') }}</p>
              </div>
              <v-textarea
                  v-model="sosType.nameEng"
                  :placeholder="placeholderNameEng"
                  :rules="sosTypeNameEng"
                  counter="100"
                  rows="1"
                  auto-grow
                  outlined
              >
              </v-textarea> -->
              <!-- Inter-hospital alert option hidden -->
              <div class="d-flex align-center">
                <v-switch
                    inset
                    v-model="sosType.alertInterHospital"
                    @change="onSwitch"
                ></v-switch>
                <div class="text-sm-h5">{{ $t('ui.alertInterHospital') }}</div>
              </div>
            </div>
          </v-card>
          <div class="m-4">
            <v-btn
                elevation="0"
                class="no-uppercase btn-custom-primary"
                @click="onSave"
                :disabled="!isFormValid"
            >{{ $t('ui.save') }}
            </v-btn>
          </div>
        </v-card>
      </div>
    </div>
  </v-form>

</template>

<script>
import DashboardHeader from "../component/DashboardHeader";
import {API2} from "../../api";
import mixin from "../../mixin";

export default {
  name: "Create",
  components: {DashboardHeader},
  mixins: [mixin],
  props: {
    openTab: {
      type: Function,
      required: true
    },
    item: {
      type: Object,
    }
  },
  data() {
    return {
      alertInterHospital: 0,
      sosType: this.getDefaultSosType(),
      isFormValid: false,
    }
  },
  mounted() {
    this.onTab(this.item)
  },
  computed: {
    isEditMode() {
      return !!this.item
    },
    sosTypeName() {
      let name = this.sosType.name
      return [
        name.length > 0 && name.length <= 100 || this.$t("ui.MSG0045"),
        name.trim().length > 0 || this.$t("ui.MSG0045")
      ];
    },
    placeholderName() {
      return this.$t('sosType.enterName')
    },
    // sosTypeNameEng() {
    //   let nameEng = this.sosType.nameEng
    //   return [
    //     nameEng.length > 0 && nameEng.length <= 100 || this.$t("ui.MSG0045"),
    //     nameEng.trim().length > 0 || this.$t("ui.MSG0045")
    //   ];
    // },
    // placeholderNameEng() {
    //   return this.$t('sosType.enterNameEng')
    // },
    colorItems() {
      return [
        { text: this.$t('colors.blue'), value: 'blue' },
        { text: this.$t('colors.red'), value: 'red' },
        { text: this.$t('colors.pink'), value: 'pink' },
        { text: this.$t('colors.green'), value: 'green' },
        { text: this.$t('colors.white'), value: 'white' },
        { text: this.$t('colors.orange'), value: 'orange' },
        { text: this.$t('colors.yellow'), value: 'yellow' },
        { text: this.$t('colors.purple'), value: 'purple' },
        { text: this.$t('colors.brown'), value: 'brown' },
        { text: this.$t('colors.black'), value: 'black' },
        { text: this.$t('colors.grey'), value: 'grey' },
        { text: this.$t('colors.silver'), value: 'silver' },
      ]
    }
  },
  methods: {
    onGoBack() {
      this.openTab(0)
    },
    onTab(item) {
      this.$refs.form.resetValidation()
      this.sosType = this.getDefaultSosType()
      if (item) this.getData(item)
    },
    getDefaultSosType() {
      return {
        name: '',
        color: 'blue',
        alertInterHospital: 0,
        // nameEng: '',
      }
    },
    async getData(item) {
      let res = await this.get(API2.SOS_TYPE, {path: item.data.sosTypeId})
      if (res) {
        this.sosType = res
        this.alertInterHospital = res?.alertInterHospital
      } else {
        // No data found, show popup message and go back to list
       this.onGoBack();
      }
    },
    async onSave() {
      const data = {
        name: this.sosType.name,
        color: this.sosType.color,
        // nameEng: this.sosType.nameEng,
        alertInterHospital: this.sosType.alertInterHospital,
      }
      if (this.item) data.path = this.sosType.sosTypeId
      let res = this.item ? await this.put(API2.SOS_TYPE, data) : await this.post(API2.SOS_TYPE, data)
      if (!res) return
      this.showToast("success", this.$t('ui.toastSuccess'), '')
      this.openTab(0)
    },
    onSwitch(newValue) {
      this.sosType.alertInterHospital = newValue ? 1 : 0
    },
  },
}
</script>

<style scoped>

.v-input {
  font-size: 22px;
}

.card-border-10 >>> .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
  color: rgba(217, 217, 217, 1);
}

</style>
